import React, { useCallback } from 'react';
import { useAppSelector, useAppDispatch } from '@/store/hooks';
import { removeToast } from '@/store/slices/uiSlice';
import Toast from './Toast';
import { ToastNotify } from '@/types/toast';

/**
 * ToastContainer - Global toast notification manager
 * Displays all toasts from Redux store
 * Should be placed once in the App component
 */
const ToastContainer: React.FC = () => {
  const toasts = useAppSelector((state) => state.ui.toasts);
  const dispatch = useAppDispatch();

  const handleClose = useCallback((id: string) => {
    dispatch(removeToast(id));
  }, [dispatch]);

  return (
    <>
      {toasts.map((toast: ToastNotify) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          position={toast.position}
          duration={toast.duration}
          onClose={() => handleClose(toast.id)}
        />
      ))}
    </>
  );
};

export default ToastContainer;
